import nookies from 'nookies';
import { VirtualAssistantRepository } from '@/components/virtual-assistant/virtual-assistant.repository';

export const makeRequestAdvice = (repository: VirtualAssistantRepository, storeId: string) => {
	return async (request: string, init: boolean, contentId: string | null, pageType: string | null) => {
		const sessionId = nookies.get()['assistantSessionId'];
		const actorId = nookies.get()['token'];
		if (sessionId) {
			nookies.set(null, 'assistantSessionId', sessionId || '', { expiresIn: '2d' });
		}
		const response = await repository.submit(request, init, sessionId, actorId, storeId, contentId, pageType);
		if (!sessionId || (sessionId === '' && response)) {
			nookies.set(null, 'assistantSessionId', response.sessionId || '', { expiresIn: '2d' });
		}
		return response;
	};
};
